import {useEffect} from 'react';
import {pauseSmoothScroll, resumeSmoothScroll} from '@/util/motion/smoothScroll';

/**
 * Suspends Lenis while `locked` is true.
 *
 * MUI's Modal (Dialog, Drawer, Popover) locks page scrolling by setting
 * `overflow: hidden` on <body> and compensating the scrollbar width. Lenis
 * keeps its own rAF loop running and keeps writing scrollTop, so without this
 * the page can drift behind an open dialog and the scroll position is lost on
 * close.
 *
 * Safe to call even when Lenis never mounted (mobile, reduced-motion) — the
 * pause/resume helpers are no-ops when there is no registered instance.
 */
const useSmoothScrollLock = (locked: boolean): void => {
    useEffect(() => {
        if (!locked) return undefined;
        pauseSmoothScroll();
        return () => resumeSmoothScroll();
    }, [locked]);
};

export default useSmoothScrollLock;
